import { render, staticRenderFns } from "./AddHorseLot.vue?vue&type=template&id=997cdbcc&"
import script from "./AddHorseLot.vue?vue&type=script&lang=js&"
export * from "./AddHorseLot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports